(function () {

    'use strict';

    angular
        .module('app.search')
        .factory('SearchResultCacheService', [
            '$cacheFactory',
            SearchResultCacheService
        ]);

    function SearchResultCacheService($cacheFactory) {
        return $cacheFactory('SearchResultCacheService', {
            capacity: 3
        });
    }

})();


// WEBPACK FOOTER //
// ./app/search/components/service/SearchResultCacheService.js